module.exports = __webpack_public_path__ + "img/COMPLEX_SOLUTION.ce144302.jpg";